import { Autocomplete, Card, CardContent, Popper, TextField } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const CardAutocompleteComponent = ({
  handleChange = () => { },
  metric,
  options,
}) => {
  const { t } = useTranslation();
  useEffect(() => { }, [t])

  return (
    <Card>
      <CardContent
        sx={{
          "&.MuiCardContent-root": { pt: 0, pb: 0.6, pl: 1.6, pr: 1.6 },
        }}
      >
        <Autocomplete
          noOptionsText={t('No Options')}
          disableClearable
          options={
            options &&
            options.sort((a, b) => -b.firstLetter?.localeCompare(a.firstLetter))
          }
          defaultValue={metric}
          value={metric}
          isOptionEqualToValue={(option, value) => option.value === value.value}

          getOptionLabel={(option) => t(option.label) || ""}
          name="metric"
          onChange={(e, value) => handleChange(value)}
          renderInput={(params) => (
            <TextField
              {...params}
              name="metric"
              label={t("Select the Metric")}
              margin="normal"
            />
          )}
          size="small"
          PopperComponent={({ style, ...props }) => (
            <Popper
              {...props}
              style={{ ...style, zIndex: 20 }}
            />
          )}
        />
      </CardContent>
    </Card>
  );
};

export default CardAutocompleteComponent;
